// app/middleware/notFoundKingOfKingsNations.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "king-of-kings") {
    throw createError({ statusCode: 404 });
  }
});
